export const signInWithGoogle = () =>
  window.location.assign("/api/auth/google");

export const signOut = () => {
  localStorage.removeItem("usersaarthi");
  window.location.assign("/api/auth/logout");
};
